import { createReducer, on } from '@ngrx/store';
import { SettingsState } from './settings.model';
import {
  LoadSettings,
  LoadSuccessSettings,
  SetFailureSettings,
} from './settings.actions';

const initialState: SettingsState = {
  byOrg: {},
  failed: {},
};

export const SettingsReducer = createReducer(
  initialState,

  /** A new attempt: whatever the last one ended as no longer applies. */
  on(LoadSettings, (state, { orgId }) => ({
    ...state,
    failed: { ...state.failed, [orgId]: false },
  })),

  on(LoadSuccessSettings, (state, { id, data }) => {
    if (!id) {
      return state;
    }

    return {
      ...state,
      byOrg: { ...state.byOrg, [id]: data },
      failed: { ...state.failed, [id]: false },
    };
  }),

  /**
   * Nothing lands in `byOrg`, so this flag is the only record that the load
   * finished at all — see `SettingsState`.
   */
  on(SetFailureSettings, (state, { orgId }) => ({
    ...state,
    failed: { ...state.failed, [orgId]: true },
  })),
);
